module.exports = __webpack_public_path__ + "static/media/telegram.48078ba6.png";